// Shared async-state UI affordances for live (API-backed) screens — a periwinkle
// spinner and an inline error row with a retry button. Self-contained (inline
// styles + the brand periwinkle) so any module can import them without pulling
// in the big app's component file. Introduced in W2; reused by W3+.

import React from "react";

const PERIWINKLE = "#4F6FE8";

export function Spinner({ size = 18, color = PERIWINKLE }) {
  return (
    <span
      aria-label="Loading"
      role="status"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: `2px solid ${color}33`,
        borderTopColor: color,
        borderRadius: "50%",
        animation: "gh-spin 0.7s linear infinite",
      }}
    >
      <style>{`@keyframes gh-spin{to{transform:rotate(360deg)}}`}</style>
    </span>
  );
}

// Centered loading state for a panel/table region while the first fetch runs.
export function LoadingBlock({ label = "Loading…", className }) {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        padding: "40px 16px",
        color: "#94a3b8",
        fontSize: 13,
      }}
    >
      <Spinner /> {label}
    </div>
  );
}

// Inline error with a retry affordance. `onRetry` wires to the hook's reload().
export function InlineError({ message, onRetry, className }) {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        margin: "8px 0",
        background: "rgba(229,72,77,0.10)",
        color: "#b91c1c",
        border: "1px solid rgba(229,72,77,0.25)",
        borderRadius: 8,
        padding: "10px 13px",
        fontSize: 13,
      }}
    >
      <span>{message || "Something went wrong."}</span>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          style={{
            border: "none",
            borderRadius: 7,
            padding: "5px 12px",
            background: PERIWINKLE,
            color: "#fff",
            fontWeight: 600,
            fontSize: 12.5,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          Retry
        </button>
      ) : null}
    </div>
  );
}
